import { useEffect, useState } from "react";
import { useMap } from "@vis.gl/react-google-maps";
import { useMapDrawing } from "../../../hooks/useMapDrawing";

// Two-phase parking tool: draw a polygon, then click to place the parking marker.
// Replaces the removed drawing.DrawingManager with the custom click-to-draw engine.
export const ParkingDrawingTools = ({ onPolygonComplete }) => {
  const map = useMap();
  const [pendingCoordinates, setPendingCoordinates] = useState(null);

  const placingMarker = pendingCoordinates !== null;

  // Phase 1 — draw the polygon. Disabled while we wait for the marker click.
  useMapDrawing({
    map,
    type: "POLYGON",
    active: !placingMarker,
    polygonOptions: {
      fillColor: "#722ed1",
      fillOpacity: 0.3,
      strokeColor: "#722ed1",
      strokeWeight: 2,
    },
    onComplete: ({ coordinates }) => {
      setPendingCoordinates(coordinates);
    },
  });

  // Phase 2 — next map click places the parking marker.
  useEffect(() => {
    if (!map || !placingMarker || !window.google?.maps) return undefined;

    const clickListener = map.addListener("click", (event) => {
      if (!event.latLng) return;
      const marker = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      onPolygonComplete({ coordinates: pendingCoordinates, marker });
      setPendingCoordinates(null);
    });

    return () => clickListener.remove();
  }, [map, placingMarker, pendingCoordinates, onPolygonComplete]);

  // Instructions overlay shown during the marker-placement phase.
  useEffect(() => {
    if (!map || !placingMarker) return undefined;

    const instructionDiv = document.createElement("div");
    instructionDiv.style.cssText = `
      position: absolute;
      top: 120px;
      left: 50%;
      transform: translateX(-50%);
      background: #722ed1;
      color: white;
      padding: 12px 24px;
      border-radius: 8px;
      font-size: 14px;
      font-weight: 500;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      z-index: 1000;
    `;
    instructionDiv.textContent =
      "📍 Cliquez sur la carte pour placer le marqueur du parking";

    const mapDiv = map.getDiv();
    mapDiv.style.position = "relative";
    mapDiv.appendChild(instructionDiv);

    return () => {
      if (mapDiv.contains(instructionDiv)) {
        mapDiv.removeChild(instructionDiv);
      }
    };
  }, [map, placingMarker]);

  return null;
};
